
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LocalStorageService, PaginatedList } from '../../xform-compat';
import { Observable } from 'rxjs';
import { Note, Thesis, ThesisHistory } from '../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private REGEX = /src="(?:\.\.)?(?:\/?api\/rms)?\/attachments\/(\d*)(?:\?access_token=[^"]*)?"/ig;
  constructor(private localStorageService: LocalStorageService) {}

  /**
   * Find and add access token querystring to inline attachments and images
   * @param content
   */
  public formatInlineImageContent(content: string): string {
    if (!content) {
      return;
    }
    const tokenInfo = this.localStorageService.get('tokenInfo');
    const token = tokenInfo.accessToken;
    return content.replace (this.REGEX, 'src="/api/rms/attachments/$1?access_token=' + token + '"');
  }

  /**
   * Remove any access token params from images before saving
   * @param content
   */
  public formatInlineImageContentRemove(content: string): string {
    return content.replace (this.REGEX, 'src="/attachments/$1"');
  }

  /**
   * Runs the inline image formatter for all items in a PaginatedList of Note objects
   * @param response
   */
  public formatInlineImageObservablePaginatedNote(response: Observable<PaginatedList<Note>>): Observable<PaginatedList<Note>> {
    return response.pipe(map((data) => {
      data.records.map((note) => {
        note.textContent.content = this.formatInlineImageContent(note.textContent.content);
        return note;
      });
      return data;
    }));
  }

  /**
   * Runs the inline image formatter for all items in an Array of Notes
   * @param response
   */
  public formatInlineImageObservableNoteArray(response: Observable<Array<Note>>): Observable<Array<Note>> {
    return response.pipe(map((data) => {
      data.map((note) => {
        note.content = this.formatInlineImageContent(note.content);
        return note;
      });
      return data;
    }));
  }

  /**
   * Runs the inline image formatter for a Note
   * @param response
   */
  public formatInlineImageObservableNote(response: Observable<Note>): Observable<Note> {
    return response.pipe(map((data) => {
      data.textContent.content = this.formatInlineImageContent(data.textContent.content);
      return data;
    }));
  }

  /**
   * Runs the inline image formatter for a Thesis
   * @param response
   */
  public formatInlineImageObservableThesis(response: Observable<Thesis>): Observable<Thesis> {
    return response.pipe(map((data) => {
      data.textContent.content = this.formatInlineImageContent(data.textContent.content);
      return data;
    }));
  }

  /**
   * Runs the inline image formatter for all items in an Array of a Thesis
   * @param response
   */
  public formatInlineImageObservableThesisArray(response: Observable<Array<ThesisHistory>>): Observable<Array<ThesisHistory>> {
    return response.pipe(map((data) => {
      data.map((thesis) => {
        thesis.content = this.formatInlineImageContent(thesis.content);
        return thesis;
      });
      return data;
    }));
  }
}
